import Joi from 'joi';

export const ActivateLicenseValidator = {
  schema: Joi.object({}).unknown(true)
};
